import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('clientManagement.managementDetail.billingInfoTitle')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.newestUpdated.updatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdated.updatedByName), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12",
          label: _ctx.$t('clientManagement.managementDetail.whatsappNumber'),
          value: _ctx.formattedWhatsappNumber
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-6/12 capitalize",
          label: _ctx.$t('clientManagement.managementDetail.billingSchedule'),
          value: _ctx.detailData.clientBilling.billingSchedule
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-7/12",
          label: _ctx.$t('clientManagement.managementDetail.paymentTerm'),
          value: `${_ctx.detailData.clientBilling.timeRangePayment} ${_ctx.$t('clientManagement.managementDetail.day')}`
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          class: "w-7/12",
          label: _ctx.$t('clientManagement.managementDetail.email'),
          value: _ctx.detailData.clientBilling.formattedEmail
        }, null, 8, ["label", "value"])
      ])
    ])
  ], 64))
}